export const textToId = (text: string, delimiter = "-"): string => {
	let id: string = text.toLowerCase();
	id = id.replace(/\s/g, delimiter);
	id = id.replace(/[^\w\-]/g, "");
	id = id.replace(new RegExp(`${delimiter}+`, "gm"), delimiter);

	return id;
};
